import { makeStyles } from '@material-ui/core/styles'

export const fileStyles = makeStyles(() => ({
    btnUpload: {
        backgroundColor: '#33949E', color: 'white'
    },
    divImage: {
        display: 'flex', flexDirection: 'column'
    },
    fileName: {
        marginLeft: 10, marginRight: 10, fontWeight: 'bold'
    },
    imgWrapper: {
        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'
    },
    img: {
        maxWidth: 300, maxHeight: 300
    },
    btn: {
        marginLeft: 10, cursor: 'pointer'
    }
}))
